/* eslint-disable react/jsx-no-target-blank */
import React, { useState, useEffect } from 'react'
import { useSelector } from 'react-redux'
import { Grid, Button } from '@material-ui/core/'
import apiAdmin from '../../../../../../../api/admin'
import './index.scss'

const Content = () => {
  const { user } = useSelector(({ session }) => session)
  const [reports, setReports] = useState([])

  const getStatistics = () => {
    apiAdmin?.getStoryReports(user?.accessKey)
      .then(({ data }) => {
        if (data?.length) {
          setReports(data)
        } else {
          setReports([])
        }
      })
      .catch(error => console.error(error))
  }

  const deleteStoryReport = (uuid, type) => {
    apiAdmin?.deleteStoryReport(user?.accessKey, uuid, type)
      .then(({ data }) => getStatistics())
      .catch(error => console.error(error))
  }

  useEffect(() => {
    getStatistics()
  }, [])

  const copySrc = src => navigator.clipboard.writeText(src)

  return (
    <Grid className='reportStory'>
      <Grid className='tableHeader'>
        <Grid className='headerName'>
          Name
        </Grid>
        <Grid className='headerEmail'>
          Reports
        </Grid>
        <Grid className='headerMeetings'>
          Email
        </Grid>
        <Grid className='headerStories'>
          City
        </Grid>
        <Grid className='headerCity'>
          Action
        </Grid>
      </Grid>
      {reports?.map(({ userAbout, uuid, reportsCount, story }) => (
        <Grid className='tableBody' key={uuid}>
          <Grid className='bodyName'>
            <span>{userAbout?.name}</span>
          </Grid>
          <Grid className='bodyReport'>
            {reportsCount}
          </Grid>
          <Grid className='bodyEmail'>
            <span>
              {userAbout?.email}
            </span>
          </Grid>
          <Grid className='bodyCity'>
            <span>
              {userAbout?.town ? userAbout?.town : '-'}
            </span>
          </Grid>
          <Grid className='bodyAction'>
            <a className='linkTable' onClick={() => copySrc(`https://test.tellme.place/story/${story?.uuid}`)}>Link</a>
            <Button className='btnDeleteContent' variant='contained' onClick={() => deleteStoryReport(uuid, 'accept')}>DELETE</Button>
            <Button className='btnCansel' variant='contained' onClick={() => deleteStoryReport(uuid, 'decline')}>CLOSE</Button>
          </Grid>
        </Grid>
      ))}
    </Grid>
  )
}

export default Content
